<template>
    <h1>Settings</h1>
</template>

<script>
    export default {
        name: 'settings',
        data() {
            return {};
        },
    };
</script>



// WEBPACK FOOTER //
// Settings.vue?e87dceb2